import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { FileToUpload } from '@core/interfaces';
import { ImagePickerComponent } from './image-picker.component';

@Injectable({
  providedIn: 'root'
})
export class ImagePickerPresenter {
  loading$!: Observable<boolean>;
  editMode$!: Observable<boolean>;
  actionOnDroppedTriggered = new EventEmitter<FileToUpload[]>();
  actionOnRemovedTriggered = new EventEmitter<void>();
  actionOnErrorTriggered = new EventEmitter<void>();
  
  imageSubject = new BehaviorSubject<string|File|FileToUpload|undefined|null>(undefined);
  filesToUploadSubject = new BehaviorSubject<FileToUpload[]>([]);
  image$ = this.imageSubject.asObservable();
  filesToUpload = this.filesToUploadSubject.asObservable();
  
  view!: ImagePickerComponent;
  private destroy$ = new Subject<void>();

  setView(view: ImagePickerComponent): void {
    this.view = view;
  }

  writeValue(value: string|File|null|undefined): void {
    if (typeof value == 'undefined') {
      this.view.image = undefined;
    } else if (value === null || (typeof value) === 'string') {
      this.view.image = value as string;
    } else {
      const reader = new FileReader();
      reader.onload = (): void => {
        this.view.image = reader?.result as string;
      }
      reader.readAsDataURL(value as File);
    }

    this.imageSubject.next(value);
  }

  onDroppedImage(files: NgxFileDropEntry[]): void {
    files.forEach(droppedFile => {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
      let file = null;
      fileEntry.file((currentFile: File) => {
        file = currentFile;
        this.view.value = file;

        if (!currentFile) return;
        
        const reader = new FileReader();
        reader.onload = (): void => {
          this.view.image = reader?.result as string;
        }
        reader.readAsDataURL(file);
        this.filesToUploadSubject.next(this.filesToUploadSubject.getValue().concat({
          fileName: fileEntry.name,
          fileEntry: file
        }))
        this.actionOnDroppedTriggered.emit(this.filesToUploadSubject.getValue());
        this.filesToUploadSubject.next([]);
      });
    });
  }

  onRemoveImage(): void {
    this.filesToUploadSubject.next([]);
    this.view.image = null;
    this.view.value = null;
    this.actionOnRemovedTriggered.emit();
  }

  onErrorImage(): void {
    this.filesToUploadSubject.next([]);
    this.view.image = null;
    this.view.value = null;
    this.actionOnErrorTriggered.emit();
  }
}
